import { Box, Stack, Text } from 'components/ui';
import type { AuthFieldShellProps } from './AuthFieldShell.props';
import { authFieldShellLabelRowSx, authFieldShellLabelSx } from './AuthFieldShell.styles';

const AuthFieldShell = ({
  children,
  error = false,
  helperText,
  hideLabel = false,
  id,
  label,
}: AuthFieldShellProps) => {
  const resolvedHelperText = !hideLabel && error ? undefined : helperText;

  return (
    <Stack spacing={0.75}>
      {!hideLabel ? (
        <Box sx={authFieldShellLabelRowSx}>
          <Box component="label" htmlFor={id} sx={authFieldShellLabelSx}>
            <Text component="span" variant="body2" visualVariant="fieldLabel">
              {label}
            </Text>
          </Box>
          {error && helperText ? (
            <Text component="span" variant="caption" visualVariant="fieldInlineError">
              {helperText}
            </Text>
          ) : null}
        </Box>
      ) : null}
      {children(resolvedHelperText)}
    </Stack>
  );
};

export default AuthFieldShell;
